import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from './components/Header';
import Hero from './components/Hero';
import Clients from './components/Clients';
import Services from './components/Services';
import Team from './components/Team';
import Summit from './components/Summit';
import Technologies from './components/Technologies';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import TrustpilotSection from './components/TrustpilotSection';
import KlarnaSection from './components/KlarnaSection';
import ComeUpSection from './components/ComeUpSection';
import CodeChatSection from './components/CodeChatSection';
import AIMarketingSection from './components/AIMarketingSection';
import BusinessBotSection from './components/BusinessBotSection';
import AIAutomationSection from './components/AIAutomationSection';
import ServicesPage from './pages/Services';
import Jobs from './pages/Jobs';
import Values from './pages/Values';
import TechnologiesPage from './pages/Technologies';
import Contact from './pages/Contact';
import BookCall from './pages/BookCall';
import Purchase from './pages/Purchase';
import Payment from './pages/Payment';
import Activities from './pages/Activities';
import ActivityDetail from './pages/ActivityDetail';
import LegalNotice from './pages/LegalNotice';
import Terms from './pages/Terms';
import FAQ from './pages/FAQ';
import Thanks from './pages/Thanks';
import Waiting from './pages/Waiting';
import StatusHandler from './pages/StatusHandler';
import PaymentMethods from './pages/PaymentMethods';
import KlarnaInfo from './pages/KlarnaInfo';
import QuoteCheckout from './pages/QuoteCheckout';
import OrderSummary from './pages/OrderSummary';
import InvoiceDocument from './pages/InvoiceDocument';
import QuoteDocument from './pages/QuoteDocument';
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import ScrollToTop from './components/ScrollToTop';
import { absoluteUrl, SITE_URL } from './lib/seo';

function App() {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Couteau Suisse Digital',
    url: SITE_URL,
    logo: absoluteUrl('/swiss-army-knife.svg'),
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Couteau Suisse Digital',
    url: SITE_URL,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${absoluteUrl('/services')}?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={
          <>
            <Helmet>
              <title>Couteau Suisse Digital - Votre Partenaire Numérique</title>
              <meta name="description" content="Couteau Suisse Digital est votre partenaire pour la transformation digitale. Experts en développement web, marketing digital et solutions numériques." />
              <meta name="keywords" content="développement web, marketing digital, transformation digitale, solutions numériques, agence digitale" />
              <meta property="og:title" content="Couteau Suisse Digital - Votre Partenaire Numérique" />
              <meta property="og:description" content="Experts en développement web, marketing digital et solutions numériques pour votre transformation digitale." />
              <meta property="og:type" content="website" />
              <meta property="og:url" content={SITE_URL} />
              <link rel="canonical" href={SITE_URL} />
              <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
              <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
            </Helmet>

            <main>
              <Hero />
              <TrustpilotSection />
              <Services />
              <CodeChatSection />
              <AIAutomationSection />
              <AIMarketingSection />
              <BusinessBotSection />
              <KlarnaSection />
              <Clients />
              <ComeUpSection />
              <Team />
              <Summit />
              <Technologies />
              <CTASection />
            </main>
          </>
        } />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/metiers" element={<Jobs />} />
        <Route path="/valeurs" element={<Values />} />
        <Route path="/technologies" element={<TechnologiesPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/reserver" element={<BookCall />} />
        <Route path="/acheter/:serviceId" element={<Purchase />} />
        <Route path="/payment/:serviceId" element={<Payment />} />
        <Route path="/devis/:paymentLinkKey" element={<QuoteCheckout />} />
        <Route path="/commande/:orderNumber" element={<OrderSummary />} />
        <Route path="/documents/facture/:invoiceNumber" element={<InvoiceDocument />} />
        <Route path="/documents/devis/:quoteNumber" element={<QuoteDocument />} />
        <Route path="/activites" element={<Activities />} />
        <Route path="/activites/:industryId" element={<ActivityDetail />} />
        <Route path="/mentions-legales" element={<LegalNotice />} />
        <Route path="/conditions-generales" element={<Terms />} />
        <Route path="/moyens-de-paiement" element={<PaymentMethods />} />
        <Route path="/klarna-info" element={<KlarnaInfo />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/status-handler" element={<StatusHandler />} />
        <Route path="/merci" element={<Thanks />} />
        <Route path="/attente" element={<Waiting />} />
        <Route path="/admin/login" element={<Login />} />
        <Route path="/admin/dashboard" element={<Dashboard />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
